module.exports = __webpack_public_path__ + "img/icon-letter.svg?e8fda1f8e7f997334d1f8a7bab6a44c1";